<template>
  <div v-if="content" class="parc-menu-component">
    <div :style="gridSize(items.length)" class="parc-menu">
      <parc-menu-item :content="item" v-for="(item) in items" :key="item.uid"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  methods: {
    gridSize(len) {
      return {
        gridTemplateColumns: `repeat(${len}, 1fr)`
      };
    }
  },
  computed: {
    items() {
      return this.submenus[this.content.menu.id] ? 
      this.submenus[this.content.menu.id].items.filter(item => {
        return (
          item.link.cached_url.replace("/pages", "") !== this.$route.fullPath
        );
      }) : []
    },
    submenus() {
      return this.$store.getters.submenus;
    }
  }
};
</script>

<style lang="scss">
.parc-menu {
  display: grid;
  width: $content-width;
  max-width: $max-width;
  grid-gap: 12px;
  padding: 0;
  margin: 120px auto;
  margin-bottom: 60px;
}

@media screen and(max-width:$desktop) {
  .parc-menu {
    display: flex;
    flex-direction: column;
    margin: 60px auto;
    margin-bottom: 0;
    > div {
      margin: auto;
      margin: 2em auto;
      margin-bottom: 3em;
    }
  }
}
</style>
